import { connect, MapStateToProps } from 'react-redux';
import { getInitialOffset, getTotal } from '../../../../selectors/stream';
import { Props } from './TopicPage';
import { AppState } from '../../../../types/store';
import { getThisTopic, getRelatedTopics } from '../../../../selectors/page';

export type StateProps = Omit<Props, 'dropFirstTimeFlag'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  topic: getThisTopic(state),
  relatedTopics: getRelatedTopics(state),
  estTotal: getTotal(state),
  initialOffset: getInitialOffset(state),
});

export default connect(mapStateToProps);
